import { z } from 'zod';

import { pathOrUrlOrEmpty } from '../../utils/zod-helpers';
import { ExtraRip, FreeCredit, LootBox, StashOrPass } from '../constants/golden-tickets';
import { UpdateGoldenTicketDataSchema } from './messages/UpdateGoldenTicket';

export const GOLDEN_TICKETS = z.enum([StashOrPass, ExtraRip, FreeCredit, LootBox]);
export const GoldenTicketSchema = z.object({
    id: z.string(),
    imageFront: pathOrUrlOrEmpty,
    imageBack: pathOrUrlOrEmpty,
    ticketType: GOLDEN_TICKETS,
    updateGoldenTicketData: UpdateGoldenTicketDataSchema,
});

export type GoldenTicket = z.infer<typeof GoldenTicketSchema>;
